export const POORVIKA_URL = "https://onmoplus.com/shop/poorvika";
export const FLIPKART_URL = "https://onmoplus.com/shop/flipkart";
